import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../common/formInputsV2/styles/tokens';

export const RcQuotesStyles = styled.div`
  margin-bottom: 80px;

  .failed-quotations-block {
    margin-top: 120px;
  }
  .failed-quotations-block img {
    width: 100%;
    display: block;
    aspect-ratio: 6/3;
    object-fit: contain;
    mix-blend-mode: multiply;
  }
`;

export const FailedQuotesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 112px;
  height: 64px;
  padding: 8px;
  border: 1px solid ${v2Colors.disabledSurface};
  border-radius: 12px;
  background: ${v2Colors.inputBackground};

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    width: 88px;
    height: 52px;
    padding: 6px;
  }
`;

export const FailedQuoteTitle = styled.h3`
  margin: 0 0 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${v2Colors.disabledBorder};
  color: ${v2Colors.text};
  font-family: ${v2FontFamily};
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
`;

// "Avviso!" — quote failed due to an insurance-data issue, contact the
// backoffice. Replaces the plain Bootstrap `alert alert-info`.
export const AvvisoAlert = styled.div`
  margin: 0 0 16px;
  padding: 14px 18px;
  border: 1px solid ${v2Colors.warningBorder};
  border-radius: 12px;
  background: ${v2Colors.warningSoft};
  font-family: ${v2FontFamily};

  h4 {
    margin: 0 0 6px;
    color: ${v2Colors.warningText};
    font-size: 15px;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: ${v2Colors.text};
    font-size: 13.5px;
    line-height: 1.5;
  }
`;

export const ProdottiCorrelatiText = styled.h2`
  color: var(--common-black, #1a1921);
  font-feature-settings: "clig" off, "liga" off;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  margin-bottom: 0;
`;

export const QuoteLoader = styled.span`
  width: 50px;
  height: 50px;
  background: rgb(0, 166, 81);
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
`;
